/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export const SIZE = ({
  small: 'small',
  medium: 'medium',
  large: 'large'
} as const);
export const INTENT = ({
  default: 'default',
  positive: 'positive',
  warning: 'warning',
  negative: 'negative',
  brand: 'brand'
} as const);